import React from 'react'
import { useSwiper } from 'swiper/react'
import { to400Image } from '~/utils'
import { AutoScroll } from '~/components/ui/AutoScroll'
import styles from './Navigation.module.css'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { detailSwiperIndexAtom } from '../atom'
import { ImageType } from '.'

const Navigation = ({ images }: { images: ImageType[] }) => {
  const [index, setIndex] = useAtom(detailSwiperIndexAtom)
  const swiper = useSwiper()
  swiper.on('slideChange', item => {
    setIndex(item.realIndex)
  })
  return (
    <AutoScroll activeIndex={index} className="my-6">
      <div className="flex justify-start items-center mx-auto">
        {images.map((it, i) => (
          <div
            key={it.url}
            className={classNames(styles.navigation, 'flex-shrink-0', {
              active: index === i,
            })}
            onClick={() => {
              swiper.slideToLoop(i)
            }}
            style={{
              width:
                it.width && it.height
                  ? Math.floor((80 * it.width) / it.height)
                  : 80,
            }}
          >
            <img
              className="rounded-lg overflow-hidden object-cover"
              src={to400Image(it.url)}
              alt=""
            />
          </div>
        ))}
      </div>
    </AutoScroll>
  )
}

export default Navigation
